import {generateClient} from 'aws-amplify/api';

const chatClient = generateClient({
  endpoint: process.env.CHAT_APPSYNC_FE_URL ?? '',
  authMode: 'apiKey',
  apiKey: process.env.CHAT_APPSYNC_FE_API_KEY ?? '',
});

export const chatAppSync = chatClient;
